module.exports = function nodesConfigToObject(nodesConfig) {
	let configs = {};
	for (const config of nodesConfig) {
		configs[config.type] = config;
	}
	return configs;
};
